export default __webpack_public_path__ + "static/media/upload.31fd0387.svg";